import { Box } from '@mui/material'
import { GridToolbarExport, GridToolbarQuickFilter } from '@mui/x-data-grid'

const CustomToolbar = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2, alignItems: 'center' }}>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'flex-end' }}>
        <GridToolbarQuickFilter
          sx={{
            verticalAlign: 'middle',
            marginBottom: 0,
            paddingBottom: 0
          }}
        />
        <GridToolbarExport
          sx={{
            '&.MuiButton-root': {
              backgroundColor: '#FC3E6F',
              color: 'white',
              px: 2,
              '&:hover': {
                backgroundColor: '#FC3E6F'
              }
            }
          }}
        />
      </Box>
    </Box>
  )
}

export default CustomToolbar
